import React from 'react';
import { AiFillGithub } from 'react-icons/ai';
import { FaLinkedinIn } from 'react-icons/fa';
import { SOCIAL_LINKS } from '../../config/constants';

function SocialLinks({ variant = 'default' }) {
  const isFooter = variant === 'footer';
  const isHome = variant === 'home';

  const linkClass = isHome ? 'icon-colour home-social-icons' : '';
  const containerClass = isHome ? 'home-about-social-links' : 'footer-icons';

  return (
    <ul className={containerClass}>
      <li className="social-icons">
        <a
          href={SOCIAL_LINKS.github}
          style={isFooter ? { color: 'white' } : {}}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          <AiFillGithub />
        </a>
      </li>
      <li className="social-icons">
        <a
          href={SOCIAL_LINKS.linkedin}
          style={isFooter ? { color: 'white' } : {}}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          <FaLinkedinIn />
        </a>
      </li>
    </ul>
  );
}

export default SocialLinks;